import {Box, Text} from "@mantine/core";
import {useContext} from "react";
import {GPTMetaContext} from "../MetaProvider";
import {SearchResultsRenderer} from "../../artifacts/SearchResultsRenderer";
import {resolveResourcesFence} from "./selectedResources";
import classes from "./StructuredBlock.module.css";
import {useTranslation} from "react-i18next";

export function ResourcesBlock({text}: {text: string}) {
    const meta = useContext(GPTMetaContext);
    const {t} = useTranslation();
    const resolution = resolveResourcesFence(text.trim(), meta?.artifacts, !!meta?.isStreaming);

    if (resolution.status === "pending") {
        return (
            <Box
                my="sm"
                className={classes.skeleton}
                role="status"
                aria-busy="true"
                aria-label={t("chat.resources.loading", {defaultValue: "Loading selected resources"})}
            />
        );
    }
    if (resolution.status === "invalid") {
        return (
            <Text my="sm" size="sm" c="dimmed" role="status">
                {t("chat.resources.unavailable", {defaultValue: "The selected resources could not be displayed."})}
            </Text>
        );
    }

    const selectedArtifact = {
        ...resolution.artifact,
        payload: {...resolution.artifact.payload, results: resolution.results},
    };
    return (
        <Box my="sm" id={`selected-resources-${resolution.artifact.id}`}>
            <SearchResultsRenderer
                artifact={selectedArtifact}
                title={resolution.view === "search" ? undefined : t("chat.resources.selected", {defaultValue: "Selected resources"})}
                messageContent={resolution.view === "search" ? meta?.answerText : undefined}
            />
        </Box>
    );
}
